import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8ed29c41.js';
import './chunk-75a5af93.js';
import './chunk-d92f0cd9.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-ae8ab23a.js';
import { A as Autocomplete } from './chunk-6019fd7a.js';
export { A as BAutocomplete } from './chunk-6019fd7a.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;
